import React from 'react'

export default props => {
  return (
    <svg
      width={14}
      height={8}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.707 7.707a1 1 0 0 0 0-1.414l-6-6a1 1 0 0 0-1.414 0l-6 6a1 1 0 0 0 1.414 1.414L7 2.414l5.293 5.293a1 1 0 0 0 1.414 0Z"
        fill="#00112B"
      />
    </svg>
  )
}
